import React, { useState } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Alert,
  Spinner
} from "react-bootstrap";

function DirectUpload() {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    setStatus(`Uploading original file: ${(file.size / 1024 / 1024).toFixed(2)} MB`);

    const formData = new FormData();
    formData.append("video", file);

    try {
      setStatus("Uploading to server...");
      await fetch("https://extapi.jacuji.com/api/videos/upload", {
        method: "POST",
        body: formData,
      });
      setStatus("Upload completed successfully ✅");
    } catch (error) {
      setStatus("Upload failed ❌");
    }

    setLoading(false);
  };

  return (
    <Container className="mt-5">
      <Card className="shadow">
        <Card.Body>
          <Card.Title className="mb-3">
            Direct Video Upload (No Frontend Compression)
          </Card.Title>

          <Form.Group className="mb-3">
            <Form.Control type="file" accept="video/*" onChange={upload} />
          </Form.Group>

          {loading && <Spinner animation="border" size="sm" />}
          {status && <Alert className="mt-3">{status}</Alert>}

          <Button disabled>Upload happens automatically</Button>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default DirectUpload;
